<script setup lang="ts">
const props = defineProps({
    blok: Object,
})

const localePath = useLocalePath()

const { state } = useAppStore()

const columns = ref([
    {
        id: 1,
        content: props.blok?.traceability,
        image: null,
        width: 'w-3/12',
        border: false,
    },
    {
        id: 2,
        content: props.blok?.living_income,
        image: props.blok?.living_income_image,
        width: 'w-5/12',
        border: true,
    },
    {
        id: 8,
        content: props.blok?.gender,
        image: null,
        width: 'w-3/12',
        border: true,
    },
    {
        id: 6,
        content: props.blok?.pesticides,
        image: null,
        width: 'w-4/12',
        border: false,
    },
    {
        id: 3,
        content: props.blok?.child_labor,
        image: null,
        width: 'w-4/12',
        border: true,
    },
    {
        id: 4,
        content: props.blok?.deforestation,
        image: null,
        width: 'w-4/12',
        border: true,
    },
    {
        id: 5,
        content: props.blok?.agroforestry,
        image: null,
        width: 'w-8/12',
        border: false,
    },
])
</script>

<template>
    <section class="section">
        <UiContainer>
            <div class="bg-chsc-indigo-500 p-20 rounded-[30px] relative max-[641px]:p-10">
                <img

                    :src="blok?.character1.filename"
                    class="absolute top-[300px] right-0 translate-x-1/3 max-[769px]:hidden"
                >
                <img

                    :src="blok?.character2.filename"
                    class="absolute top-[800px] left-0 -translate-x-2/3 max-[769px]:hidden"
                >
                <header class="mb-20 text-center [&>h2]:font-eb-garamond [&>h2]:text-white [&>h2]:fs-6xl [&>h2]:mb-8 [&>p]:font-londrina-solid [&>p]:text-chsc-yellow [&>p]:fs-2xl">
                    <StoryblokRichText :doc="blok?.header" />
                </header>
                <div class="flex flex-wrap -m-8 [&>div]:p-8">
                    <div
                        v-for="column in columns"
                        :key="column.id"
                        :class="[
                            column.width,
                            'max-[769px]:w-full max-[769px]:border-none',
                            { '-mt-8': column.id === 5 },
                            { 'border-l border-white': column.border },
                        ]"
                    >
                        <h4 class="mb-4 font-londrina-solid text-chsc-yellow fs-3xl uppercase leading-[26px]">
                            {{ useCategoryName(state.categories, column.id) }}
                        </h4>
                        <div
                            v-if="column.image"
                            class="mb-4 mix-blend-screen"
                        >
                            <img
                                :src="column.image?.filename"
                                :alt="column.image?.alt"
                                class="w-full"
                            >
                        </div>
                        <div class="flex flex-col space-y-4 font-londrina-solid text-white [&>p]:fs-2xl [&>h4]:fs-4xl">
                            <StoryblokRichText :doc="column.content" />
                        </div>
                    </div>
                </div>
                <div class="mt-20">
                    <header class="text-center relative mb-12">
                        <h2 class="relative font-eb-garamond text-white fs-6xl inline-flex bg-chsc-indigo-500 px-9 z-1">
                            {{ blok?.insights_title }}
                        </h2>
                        <div class="w-full h-px bg-white absolute top-1/2 -translate-y-1/2 " />
                    </header>
                    <div class="grid grid-cols-4 gap-8 max-[1025px]:grid-cols-3 max-[769px]:grid-cols-2 max-[641px]:grid-cols-1">
                        <StoryblokComponent
                            v-for="item in blok?.insights"
                            :key="item"
                            v-editable="item"
                            :blok="item"
                        />
                    </div>
                </div>
            </div>
            <footer class="mt-14 flex justify-center">
                <UButton
                    :to="localePath('/insights')"
                    :label="blok?.more"
                    size="xl"
                />
            </footer>
        </UiContainer>
    </section>
</template>
